import * as React from 'react';
import type { SVGProps } from 'react';
const SvgChevronDown = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} fill="none" {...props}>
    <g clipPath="url(#chevron-down_svg__a)">
      <path
        fill="#960045"
        fillRule="evenodd"
        d="M15.06 5.001A.75.75 0 0 1 15 6.061l-6.741 6a.75.75 0 0 1-1.018-.02l-6.259-6A.75.75 0 1 1 2.019 4.96l5.76 5.52L14 4.94a.75.75 0 0 1 1.06.062"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="chevron-down_svg__a">
        <path fill="#fff" d="M.5.5h15v15H.5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgChevronDown;
